import { Component, h } from 'preact'
import InputGroup from '../../control-components/ui-components/InputGroup'

interface EventsCalendarWidgetConfigProps {
  content: Content
  onChange: (state: {amount: number}) => void
}

interface Content {
  amount: number
}

interface State {
  amount: number
}

export class EventCalendarConfigurator extends Component<EventsCalendarWidgetConfigProps, State> {
  constructor (props: EventsCalendarWidgetConfigProps) {
    super(props)

    this.state = {
      amount: props.content.amount
    }

    this.onChangeAmount = this.onChangeAmount.bind(this)
  }

  onChangeAmount (newAmount: number) {
    this.setState({
      amount: newAmount
    }, () => this.onChangeSend())
  }

  onChangeSend () {
    this.props.onChange(this.state)
  }

  render (props: EventsCalendarWidgetConfigProps, { amount }: State) {
    return (
      <div className='event-calendar-widget__configurator'>
        <InputGroup
          title='Amount of events to display'
          type='number'
          qaClasses='qa-event-calendar-widget__amount'
          onChange={(e: {target: HTMLInputElement}) => { this.onChangeAmount(parseInt(e.target.value, 10)) }}
          value={amount}
          min={1}
        />
      </div>
    )
  }
}

export default EventCalendarConfigurator
